import Vue from 'vue';
import App from './App';
import store from './store'
import { router } from './router';

import './permission' // permission control

import '@/assets/styles/index.less' // global css


new Vue({
  router,
  store,
  el: '#app',
  render: h => h(App)
});
